import { SafeArea } from "@capacitor-community/safe-area";
import { useEffect } from "react";
import { useLoggedIn } from "@hooks/auth/useLoggedIn";

export const useSafeArea = () => {
  const loggedIn = useLoggedIn();

  useEffect(() => {
    try {
      // SafeArea.set({
      //   config: {
      //     customColorsForSystemBars: true,
      //     statusBarColor: "#026F8A",
      //     statusBarContent: "light",
      //     navigationBarColor: "#F7FAF8",
      //     navigationBarContent: "light",
      //   },
      // });
    } catch (error) {
      console.log(error);
    }
  }, [loggedIn]);
};
